import React from 'react';
import * as Sentry from '@sentry/react';
import { observer } from 'mobx-react';

import { DebugMenuStore } from '@kaltura-ott/tvpil-shared';

import LazyLoader from 'components/hoc/LazyLoader/LazyLoader';
import DownloadPageChecker from 'components/pages/DownloadPageChecker/DownloadPageChecker';
import MainLoader from 'components/presenters/MainLoader/MainLoader';
import MenuResolver from 'components/widgets/Menu/MenuResolver';
import { useAppStore, useLoadingPerformanceEvents } from 'hooks';
import { APPLICATION_SPINNER_EVENT_NAME } from 'utils';

import AppHooksCombiner from './AppHooksCombiner';
import Routes from './Routes';

import 'normalize.css';

const Gdpr = LazyLoader(() =>
  import('components/widgets/Gdpr/Gdpr').then((module) => ({ default: module.default }))
);
const Banner = LazyLoader(() =>
  import('components/widgets/Banner/Banner').then((module) => ({ default: module.default })),
);
const DebugMenu = LazyLoader(() =>
  import('components/presenters/DevMenu/DebugMenu').then((module) => ({ default: module.default })),
);

function App() {
  const {
    appStore: { dms, isReady },
  } = useAppStore();

  useLoadingPerformanceEvents(APPLICATION_SPINNER_EVENT_NAME.APP, !isReady);

  const isBanner = !!dms?.exponea?.enable;

  return (
    // TODO: change error fallback to ErrorScreen UI
    <Sentry.ErrorBoundary fallback={({ error }) => <div>{JSON.stringify(error.stack)}</div>}>
      <AppHooksCombiner />
      {isReady ? (
        <>
          <DownloadPageChecker>
            <>
              <MenuResolver />
              <Routes />
              {isBanner && (<Banner />)}
              <Gdpr />
            </>
          </DownloadPageChecker>

          {DebugMenuStore.isMutableRootCategoryId && (<DebugMenu />)}
        </>
      ) : (
        <MainLoader />
      )}
    </Sentry.ErrorBoundary>
  );
}

export default observer(App);
